export { default } from './LegalBlurb.container';
